import React from 'react';
import { business } from './siteData';
import {
  ErrorActions,
  ErrorCard,
  ErrorPage,
} from './styled/errorBoundary.style';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('KMK Drywall render error:', error, errorInfo);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <ErrorPage>
        <ErrorCard role="alert">
          <p>Website loading issue</p>
          <h1>KMK Drywall is still available.</h1>
          <span>
            The site had trouble loading on this device. Please refresh the page,
            call, or email KMK Drywall for a quote.
          </span>
          <ErrorActions>
            <a href={business.phoneHref}>Call {business.phoneDisplay}</a>
            <a href={business.emailHref}>Email KMK Drywall</a>
          </ErrorActions>
        </ErrorCard>
      </ErrorPage>
    );
  }
}

export default ErrorBoundary;
